import { defaultFaq } from "@loot-os/api-contract";
import type { FaqContent } from "@loot-os/design-system/templates/home/homeContent";
import { toRichText } from "@loot-os/design-system/templates/shared/content";
import { useTenant } from "../../../../lib/tenant.js";
import { useTerminology } from "../../../../lib/terminology.js";

/** The FAQ, in the store's name, terms and currency (`defaultFaq`). */
export function useFaqContent(): FaqContent {
  const { config } = useTenant();
  const faq = defaultFaq({
    terms: useTerminology(),
    storeName: config.name,
    currencyPlural: config.currency.namePlural || config.currency.name,
  });
  return {
    title: faq.title,
    entries: faq.entries.map(({ question, answer }) => ({
      question,
      answer: toRichText(answer),
    })),
  };
}
